/* eslint-disable max-len */
import React from 'react';
import { OperatorSetting } from '../../../models/userSettings';
import SignaturePad from '../../DefectDrawer/components/SignaturePad';
import styles from '../workpackDrawer.module.less';

interface CRSAccepptanceProps {
  setAcceptanceSig: (signature: string, signatureSvg: string, signedAt: string) => void;
  operatorSettings: OperatorSetting;
}

const CRSAcceptance = ({ setAcceptanceSig, operatorSettings }: CRSAccepptanceProps): JSX.Element => {
  const isMobile = window.innerWidth < 451;

  return (
    <div className={styles.column}>
      <span className={styles.signaturePadHeading}>{`${operatorSettings?.crs_short_name} Acceptance`}</span>
      <span className={styles.signatureSubHeading}>
        {`Sign here to accept the issued ${operatorSettings?.crs_short_name} and mark the included maintenance items as complied with.`}
      </span>
      <SignaturePad setAcceptanceSig={setAcceptanceSig} width={isMobile ? 300 : 600}
      />
    </div>
  );
};

export default CRSAcceptance;
